import { MultiSelectFieldStyledProps, ValueType } from './SelectField.types'

export function isMultiValue<OptionValueType>(
  value: ValueType<OptionValueType>,
  isMulti?: boolean,
): value is MultiSelectFieldStyledProps<OptionValueType>['value'] {
  return Boolean(isMulti) && Array.isArray(value)
}
